import styled from 'styled-components';

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
